import React from 'react';

const viewFileDoc = (props) => {
    // console.log("hello")
    const handleClick = () => {
        if (props.data.file_link && props.data.file_link !== "") {
            const docUrl = props.data.file_link;
            // console.log("docUrl",docUrl)
            const newWindow = window.open(docUrl, '_blank');
            if (newWindow) {
                newWindow.opener = null;
            }
        } else {
            console.error("Document URL is empty or undefined");
        }
    };

    // console.log("props ", props.data)
    return (
        <div>
            {
                (props.data.file_upload === 1) ?
                    

                    <button
                    onClick={handleClick}
                    style={{ padding: "0px", width: "46px", height: "21px" }}
                    className={`custom-btn f12 label label-success `}
                    // className="custom-btn f12 label label-success"
                    title="Download"
                    >
                    <i className="icofont icofont-download"></i> Download
                    </button>
                    :
                    ""
            }

        </div>
    );
};

export default viewFileDoc;